import { Crud } from "@/api";
import { LoaderFunctionArgs } from "react-router-dom";

export default async function dashboardCartLoader({
  params,
}: LoaderFunctionArgs) {
  const cartId = params.cartId as string;

  const [cart] = await Promise.all([Crud.carts.get(cartId)]);

  return { cart };
}
